export default __webpack_public_path__ + "static/media/user-status-icon-yellow.2f68fa53.svg";